import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { CreatePackPayload, IPack } from '../types';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

type UpdatePackInput = {
  id: string;
  data: CreatePackPayload;
};

export function useUpdatePack(
  options?: UseMutationOptions<IPack, Error, UpdatePackInput>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['packs', 'update'],
    mutationFn: ({ id, data }: UpdatePackInput) => packApi.update(id, data),
    ...mutationOptions,
    onSuccess: (data, variables, context) => {
      toast({ title: 'Pack atualizado com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: packKeys.detail(variables.id) });
      queryClient.invalidateQueries({ queryKey: packKeys.all });
      (providedOnSuccess as any)?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      toast({
        title: 'Erro ao atualizar pack',
        description: error.message,
        variant: 'destructive',
      });
      (providedOnError as any)?.(error, variables, context);
    },
  });
  const updatePack = (id: string, data: UpdatePackInput['data']) =>
    mutation.mutateAsync({ id, data });
  return {
    updatePack,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
